'use strict';

/* eslint: 0 */
var parallel = require('cjs-async/parallel'),
    Storage = require('../system/storage'),
    loaded = {
        // example of future structure
        // plugin package name: {
        //     version: instance
        // }
    },
    pluginLoader = {
        basePath: '',
        load: null,

        getPluginStorage: function ( name ) {
            if ( DEVELOP ) {
                debug('plugin')('resolve storage with name: ' + name);
            }

            return loaded[name].storage;
        }
    };


function resolveDependency ( dependency, callback, onReady ) {
    var xhr;


    if ( loaded[dependency.name] && loaded[dependency.name].instance ) {
        if ( DEVELOP ) {
            debug('plugin')('resolve already loaded plugin ' + dependency.name);
        }

        if ( onReady ) {
            onReady(null, loaded[dependency.name]);
        }

        callback(null, loaded[dependency.name]);
    } else if ( loaded[dependency.name] && loaded[dependency.name].loading ) {

        if ( loaded[dependency.name].dependents === null ) {
            loaded[dependency.name].dependents = [];
        }

        if ( DEVELOP ) {
            debug('plugin')('wait for plugin ' + dependency.name);
        }

        loaded[dependency.name].dependents.push(function () {
            if ( DEVELOP ) {
                debug('plugin')('dependents called for ' + dependency.name);
            }

            if ( onReady ) {
                onReady(null, loaded[dependency.name]);
            }

            callback(null, loaded[dependency.name]);
        });
    } else {
        loaded[dependency.name] = {
            loading: true,
            instance: null,
            dependents: null,
            name: dependency.name,
            path: dependency.path,
            storage: new Storage(dependency.name),
            packageName: dependency.packageName
        };

        xhr = new XMLHttpRequest();

        if ( !dependency.url ) {
            dependency.url = pluginLoader.basePath + '/' + dependency.packageName + '/' + dependency.version + '/' + (dependency.main || 'index.js');
        }

        if ( DEVELOP ) {
            debug('plugin')('load js file from ' + dependency.url);
        }

        xhr.open('GET', dependency.url, true);
        if ( DEVELOP ) { debug('plugin')('load plugin ' + dependency.url); }

        xhr.onload = function (  ) {
            var module = {
                    exports: {},
                    id: ''
                },
                /* eslint no-new-func: 0 */
                executeFunction = new Function('module', 'exports', 'require', this.responseText + '//# sourceURL=file.js'),
                dependents, dependedant;

            /* eslint no-empty-function: 0 */
            if ( DEVELOP ) {
                debug('plugin')('time to load ' + dependency.name + ' ' + (Date.now() - xhr.time));
                module.time = Date.now();

                try {
                    executeFunction(module, module.exports, function () {});
                } catch ( error ) {
                    debug('plugin')('exception in ' + dependency.name +  ': ' + error);
                }

                debug('plugin')('time to eval ' + dependency.name + ' ' + (Date.now() - module.time));
            } else {
                executeFunction(module, module.exports, function () {});
            }

            if ( DEVELOP ) {
                debug('plugin')('RESOLVED ' + dependency.name);
            }

            if ( DEVELOP ) {
                debug('plugin')('EXPORTED ' + dependency.name);
            }
            window.core.plugins[dependency.name] = loaded[dependency.name].instance = module.exports;
            loaded[dependency.name].loading = false;

            if ( onReady ) {
                onReady(null, loaded[dependency.name]);
            }

            if ( loaded[dependency.name].dependents !== null && loaded[dependency.name].dependents.length > 0 ) {
                dependents = loaded[dependency.name].dependents;
                /* eslint no-cond-assign: 0 */
                while ( dependedant = dependents.shift() ) {
                    dependedant();
                }
            }

            callback(null, loaded[dependency.name]);
        };

        if ( DEVELOP ) {
            xhr.time = Date.now();
        }

        xhr.send();
    }
}

function loadDependency ( dependency, callback, onReady ) {
    var dependencies = null,
        loaders;

    dependency = window.core.packageMap[dependency];
    if ( dependency.dependencies ) {
        dependencies = Object.keys(dependency.dependencies);
    }

    if ( dependencies !== null && dependencies.length > 0 ) {
        if ( DEVELOP ) {
            debug('plugin')('load dependencies for ' + dependency.name);
        }

        loaders = [];
        dependencies.forEach(function ( innerDependency ) {
            if ( window.core.packageMap[innerDependency] ) {
                loaders.push(function (done) {
                    loadDependency(innerDependency, done, onReady);
                });
            }
        });

        parallel(loaders, function () {
            if ( DEVELOP ) {
                debug('plugin')('try to resolve ' + dependency.name);
            }
            resolveDependency(dependency, callback, onReady);
        });
    } else {
        resolveDependency(dependency, callback, onReady);
    }
}

pluginLoader.load = function ( config ) {
    var loaders = [];

    if ( config.dependencies ) {
        config.dependencies = Object.keys(config.dependencies);
        config.dependencies.forEach(function ( dependency ) {
            if ( window.core.packageMap[dependency] ) {
                loaders.push(function ( done ) {
                    loadDependency(dependency, done, config.dependencyReady);
                });
            }
        });

        parallel(loaders, function ( error, results ) {
            if ( config.done ) {
                config.done(error, results);
            }
        });
    } else if ( config.done ) {
        config.done();
    }
};


if ( DEVELOP ) {
    window.core.addListener('keydown:117c', function () {
        Object.keys(loaded).forEach(function ( dependency ) {
            debug('plugin')('already loaded: ' + loaded[dependency].packageName);
        });
        debug('plugin')('RELOAD ALL NOT IMPLEMENTED YET!!!!!');
    });

    pluginLoader.loaded = loaded;
}


module.exports = pluginLoader;
